import React, { useState } from "react";
import Navbar from "../../commanComponents/Navbar";
import SearchBox from "../../commanComponents/inputs/SearchBox";
import ColorBtn from "../../commanComponents/buttons/ColorBtn";
import NotificationCard from "./NotificationCard";
import BackButton from "../../commanComponents/buttons/BackButton";
import toast from "react-hot-toast";
import { communication } from "../../constants/apis/communication";
import { useMutation, useQuery, useQueryClient } from "react-query";
import Loader from "../../commanComponents/Loader";
import PopupModel from "../../commanComponents/PopupModel";
import { Modal } from "react-bootstrap";
import svgData from "../../constants/utilities/svgData";

export default function Notifications() {
  const queryClient = useQueryClient();

  const {
    data: notifications,
    isFetching,
    refetch,
  } = useQuery(["getAllNotification"], () => communication?.getAllNotification(), {
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      if (data?.data?.status == "JWT_INVALID") {
        toast.error(`Failed: ${data?.data?.message}`);
      } else if (data?.data?.status == "FAILED") {
        toast.error(`Failed: ${data?.data?.message}`);
      }
    },
    onError: (error) => {
      toast.error(`Failed: ${error?.message}`);
    },
  });

  const { mutate, isLoading } = useMutation(() => communication?.markAllNotificationsAsRead(), {
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      if (data?.data?.status == "SUCCESS") {
        toast.success(`Success : ${data?.data?.message}`);
        refetch();
        queryClient.invalidateQueries(["getNotificationCount"]);
      } else {
        toast.error(`Failed : ${data?.data?.message}`);
      }
    },
    onError: (error) => {
      toast.error(`Failed to update status: ${error?.message}`);
    },
  })
  

  return (
    <>
      <div className="premiumNotificationPage">
        {(isFetching || isLoading) && <Loader />}
        
        <div className="premiumNotificationHeader">
          <div className="premiumNotificationHeaderLeft">
            <h1 className="premiumNotificationTitle">Notifications</h1>
            <p className="premiumNotificationSubtitle">View all notifications</p>
            <div className="premiumNotificationTitleDivider"></div>
          </div>
          
          <button
            className="premiumNotificationDeleteAllBtn"
            disabled={!notifications?.data?.notification || notifications?.data?.notification?.length === 0}
            onClick={() => mutate()}
          >
            Mark all as read
          </button>
        </div>

        <div className="premiumNotificationList">
          {notifications?.data?.notification?.map((ele) => {
            return <NotificationCard key={ele._id || ele.id} data={ele} refetchList={refetch} />;
          })}
          {(!notifications?.data?.notification || notifications?.data?.notification?.length === 0) && (
            <div className="premiumNotificationNoData">
              {svgData?.infoIcon}
              <h6>No notifications available</h6>
            </div>
          )}
        </div>
      </div>

    </>
  );
}
